import { Controller } from "@hotwired/stimulus";

const OPEN_EVENT = "type-picker-group:opened";

export default class extends Controller {
  static targets = ["trigger", "popover"];

  connect() {
    this.closeTimer = null;
    this.isOpen = false;
    this.onDocumentClick = this.#onDocumentClick.bind(this);
    this.onKeydown = this.#onKeydown.bind(this);
    this.onOtherOpened = this.#onOtherOpened.bind(this);
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onKeydown);
    window.addEventListener(OPEN_EVENT, this.onOtherOpened);
  }

  disconnect() {
    this.#clearCloseTimer();
    document.removeEventListener("click", this.onDocumentClick);
    document.removeEventListener("keydown", this.onKeydown);
    window.removeEventListener(OPEN_EVENT, this.onOtherOpened);
  }

  open() {
    this.#clearCloseTimer();
    if (this.isOpen) return;
    this.popoverTarget.classList.remove("hidden");
    this.isOpen = true;
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "true");
    }
    window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { source: this } }));
  }

  close() {
    this.#clearCloseTimer();
    if (!this.isOpen) return;
    this.popoverTarget.classList.add("hidden");
    this.isOpen = false;
    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute("aria-expanded", "false");
    }
  }

  toggle(event) {
    event.preventDefault();
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  scheduleClose(event) {
    if (event && event.relatedTarget && this.element.contains(event.relatedTarget)) {
      return;
    }
    this.#clearCloseTimer();
    this.closeTimer = window.setTimeout(() => this.close(), 200);
  }

  cancelClose() {
    this.#clearCloseTimer();
  }

  #clearCloseTimer() {
    if (this.closeTimer) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  #onDocumentClick(event) {
    if (!this.isOpen) return;
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  #onKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
    }
  }

  #onOtherOpened(event) {
    if (event.detail && event.detail.source === this) return;
    this.close();
  }
}
